export const FIXED_TOP = 'sections/types/FIXED_TOP';
export const FIXED_BOTTOM = 'sections/types/FIXED_BOTTOM';
export const PREHEADER = 'sections/types/PREHEADER';
export const HEADER = 'sections/types/HEADER';
export const BODY = 'sections/types/BODY';
export const FOOTER = 'sections/types/FOOTER';
